import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../../../services/api';

// Task 36 — Task 24'ün genişlettiği talent-reports uçları: 4 rapor süreç/havuz
// filtresi kazandı (nine-box-distribution/hipo-development → processId[eq],
// talent-pool → poolId[eq]) + 2 YENİ rapor (flight-risk, hipo-development).
// flight-risk niteliksel olarak farklı: yönetici için görünürlük kapalıysa BE
// 409 "talent.report.flightRiskDisabled" döner — bu config'te `disabledKey`
// alanıyla işaretlenir, TalentReportsPage skipErrorToast ile isteği atar ve
// jenerik hata toast'ı YERİNE kendi bilgi boş-durumunu gösterir (MyNineBoxPage/
// MyPeriodResultsPage'in 409 desenini tekrarlar).
export function useTalentReportConfigs() {
  const { t } = useTranslation();

  return useMemo(() => {
    const makeGet = (slug, extraConfig = {}) => (params) =>
      api.get(`/v1/talent-reports/${slug}`, { params, ...extraConfig });

    const makeExport = (slug) => (params) =>
      api.get(`/v1/talent-reports/${slug}/export`, { params, responseType: 'blob' });

    const col = (name, extra = {}) => ({
      name,
      label: t(`performance.report.col.${name}`),
      options: { filter: false, sort: false, ...extra },
    });

    // performance.talentpool.flightRisk.* — PoolMembersTab'ın flightRiskOptions'ıyla
    // AYNI anahtarlar (bağımsız tekrar).
    const flightRiskLevelLabel = (v) => t(`performance.talentpool.flightRisk.${v}`, { defaultValue: v });

    return [
      {
        slug: 'nine-box-distribution',
        label: t('performance.report.name.nine-box-distribution'),
        fetch: makeGet('nine-box-distribution'),
        export: makeExport('nine-box-distribution'),
        hasChart: true,
        needsProcess: true,
        columns: [
          {
            name: 'cellKey',
            label: t('performance.report.col.cellKey'),
            options: {
              filter: false,
              sort: false,
              // Task 36 — eski ham-token fallback'i (defaultValue: v) kaldırıldı:
              // NineBoxCellKeys.AllKeys'in 9 hücresinin tamamı performance.ninebox.cell.*
              // altında tanımlı (bkz. locale dosyaları), fallback hiçbir zaman devreye
              // girmiyordu.
              customBodyRender: (v) => t(`performance.ninebox.cell.${v}`),
            },
          },
          col('count'),
        ],
      },
      {
        slug: 'talent-pool',
        label: t('performance.report.name.talent-pool'),
        fetch: makeGet('talent-pool'),
        export: makeExport('talent-pool'),
        needsPool: true,
        columns: [
          col('employeeName'),
          col('label'),
          col('riskStatus'),
          col('targetPosition'),
        ],
      },
      {
        slug: 'succession-risk',
        label: t('performance.report.name.succession-risk'),
        fetch: makeGet('succession-risk'),
        export: makeExport('succession-risk'),
        columns: [
          col('title'),
          col('candidateCount'),
          {
            name: 'atRisk',
            label: t('performance.report.col.atRisk'),
            options: {
              filter: false,
              sort: false,
              customBodyRender: (v) =>
                v ? (
                  <span style={{ display: 'inline-block', padding: '2px 8px', borderRadius: 4, fontSize: 12, fontWeight: 700, background: '#FEE2E2', color: '#991B1B' }}>
                    {t('performance.report.col.yes')}
                  </span>
                ) : (
                  <span style={{ display: 'inline-block', padding: '2px 8px', borderRadius: 4, fontSize: 12, fontWeight: 700, background: '#D1FAE5', color: '#065F46' }}>
                    {t('performance.report.col.no')}
                  </span>
                ),
            },
          },
        ],
      },
      {
        slug: 'idp-completion',
        label: t('performance.report.name.idp-completion'),
        fetch: makeGet('idp-completion'),
        export: makeExport('idp-completion'),
        columns: [
          col('employeeName'),
          col('title'),
          col('overallProgress'),
          col('status'),
        ],
      },
      {
        // Task 24/36 (YENİ) — yönetici için görünürlük TalentSettings.
        // FlightRiskVisibleToManager==false ise BE 409 döner (skipErrorToast +
        // disabledKey → TalentReportsPage'in bilgi boş-durumu).
        slug: 'flight-risk',
        label: t('performance.report.name.flight-risk'),
        fetch: makeGet('flight-risk', { skipErrorToast: true }),
        export: makeExport('flight-risk'),
        disabledKey: 'talent.report.flightRiskDisabled',
        columns: [
          col('employeeName'),
          {
            name: 'level',
            label: t('performance.report.col.level'),
            options: { filter: false, sort: false, customBodyRender: flightRiskLevelLabel },
          },
          col('departmentName'),
          col('month'),
        ],
      },
      {
        // Task 24/36 (YENİ) — star_hipo hücresindeki çalışanların IDP özeti;
        // isAdmin=false çağıranlar yalnız kendi ekiplerini görür (BE kapsamı).
        slug: 'hipo-development',
        label: t('performance.report.name.hipo-development'),
        fetch: makeGet('hipo-development'),
        export: makeExport('hipo-development'),
        needsProcess: true,
        columns: [
          col('employeeName'),
          col('planCount'),
          col('goalCount'),
          col('actionCount'),
          col('overallProgress'),
        ],
      },
    ];
  }, [t]);
}
